<template>
  <el-row class="sys-user-info-outer">
    <el-card :body-style="{padding: 0}" class="left">
      <div class="header">
        <el-avatar :size="80" :src="getFileUrl(user.photoPath)" alt="头像" shape="square"></el-avatar>
        <div>{{user.name}}</div>
      </div>
      <el-row v-for="column in columns" :key="column.value" :class="{current: column.value === currColumnValue}" class="info-column"
        @click="currColumnValue = column.value">
        <el-icon><component :is="column.icon" /></el-icon>
        <span>{{column.name}}</span>
      </el-row>
    </el-card>

    <div class="right">
      <base-info :id="id" v-show="currColumnValue === 1" :user="user" />
      <project-list v-show="currColumnValue === 2" :userId="id" :currColumnValue="currColumnValue" />
      <wage-list v-show="currColumnValue === 3" :userId="id" :currColumnValue="currColumnValue" />
      <login-log v-show="currColumnValue === 4" :userId="id" :currColumnValue="currColumnValue" />
    </div>
  </el-row>
</template>

<script>
import { getUserById } from '@/api/sys/user';
import { defineComponent } from 'vue'
import BaseInfo from './BaseInfo.vue';
import ProjectList from './ProjectList.vue';
import WageList from './WageList.vue'
import LoginLog from './LoginLog.vue'

import { getFileUrl } from '@/utils/common';

export default defineComponent({
  components: { BaseInfo, ProjectList, WageList, LoginLog},
  data() {
    return {
      getFileUrl,
      id: null,
      user: {},
      currColumnValue: 1, // 当前栏目值
      columns: [
        { name: '用户信息', icon: 'document', value: 1 },
        { name: '项目经历', icon: 'credit-card', value: 2 },
        { name: '工资记录', icon: 'ticket', value: 3 },
        { name: '登录日志', icon: 'tickets', value: 4 }
      ]
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    if (!this.id) {
      this.back();
      return;
    }
    this.getUser();
  },
  methods: {
    back() {
      this.$router.push('/sys/user');
    },
    getUser() {
      getUserById(this.id).then(({data}) => {
        this.user = data.data;
        if (!this.user) {
          this.back();
        }
      })
    }
  }
})
</script>

<style lang="scss" scoped>
.sys-user-info-outer {
  padding: 15px;
  justify-content: space-between;
  height: 100%;
  .left {
    width: 200px;
    text-align: center;
    .header {
      height: 145px;
      padding-top: 15px;
      background-color: #f5f5f5;
      .el-avatar {
        margin-bottom: 10px;
      }
    }
    .info-column {
      justify-content: center;
      align-items: center;
      margin-top: 25px;
      cursor: pointer;
      color: #333;
      .el-icon {
        color: #ccc;
        margin-right: 15px;
      }
      &.current {
        color: blue;
        .el-icon {
          color: blue; 
        }   
      }
    }
  }
  .right {
    width: calc(100% - 220px);
  }
}
</style>